// S311: oturumsuz parola ekranlarının (Şifremi unuttum, Parola belirle) kabuğu.
// Giriş ekranının ölçülerini ve sınıflarını taşır; kullanıcı iki ekran arasında
// geçerken aynı yerde olduğunu görsün. `Login.tsx` bu kabuğu KULLANMIYOR: onun
// ölçüleri `loginOlculeri.test.ts` ile kaynak metninden kilitli, yapısına dokunmadık.
import { useState, type ReactNode } from 'react';
import { I } from './yeni-design/icons';
import { Wordmark } from './yeni-design/Wordmark';

/** Giriş ekranındaki `inputCls` ile aynı. */
export const girisInputCls =
  'w-full h-[44px] rounded-[10px] border-[0.5px] border-[#d2d2d2] bg-[#f8f8f9] ' +
  'px-3 text-[13px] max-[640px]:text-[16px] text-[#1b1b1b] placeholder:text-[#6b6b6e] ' +
  'focus:outline-none focus:border-[#123A69] focus:shadow-[0_0_0_3px_rgba(18,58,105,0.15)]';

export const girisEtiketCls = 'text-[11px] font-medium text-[#4b4b4f] mb-[5px] ml-0.5';

export const girisButonCls =
  'h-[44px] mt-1 rounded-[9999px] bg-[#123A69] text-white text-[13px] font-medium disabled:opacity-60 cursor-pointer disabled:cursor-default';

/** Sessiz ikincil bağlantı: girişteki "Şifremi unuttum" ile aynı görünüm. */
export const girisAltLinkCls =
  'self-center mt-3 text-[12px] text-[#6b6b6e] no-underline hover:text-[#2f2f31] hover:underline';

export const girisMetinCls = 'm-0 mb-4 text-[13px] leading-[1.5] text-[#4b4b4f] text-center break-words';

export const girisHataCls = 'text-[12px] text-[#b42318] text-center mt-1 mb-3';

export function GirisKabugu({ baslik, children }: { baslik: string; children: ReactNode }) {
  return (
    <div className="min-h-[100dvh] bg-[#f8f8f9] flex items-center justify-center p-6">
      <div className="w-[288px] flex flex-col">
        <div className="flex justify-center mb-[22px] [&_.text-brand-700]:text-[#123A69] [&>div]:flex-col [&>div]:gap-[12px] [&_img]:w-[64px] [&_img]:h-[64px] [&>div>span]:text-[20px] [&>div>span]:font-bold [&>div>span]:tracking-[-0.02em]">
          <Wordmark size="md" />
        </div>
        {/* Girişte başlık gizli ("ne sayfası olduğu belli"); burada o gerekçe yok, görünür. */}
        <h1 className="m-0 mb-4 text-[18px] font-medium text-[#2f2f31] text-center">{baslik}</h1>
        {children}
      </div>

      <div
        className="fixed inset-x-0 bottom-0 pointer-events-none select-none mix-blend-multiply max-[640px]:h-[120px] max-[640px]:overflow-hidden"
        aria-hidden="true"
      >
        <img
          src="/rasathane-sahne.webp"
          alt=""
          className="block w-full h-auto max-[640px]:h-[120px] max-[640px]:object-cover max-[640px]:object-[100%_100%]"
        />
      </div>
    </div>
  );
}

/** Parola alanı + göster/gizle düğmesi; giriş ekranındaki desenin aynısı. */
export function ParolaAlani({
  id,
  etiket,
  deger,
  degisti,
}: {
  id: string;
  etiket: string;
  deger: string;
  degisti: (v: string) => void;
}) {
  const [gorunur, setGorunur] = useState(false);
  return (
    <>
      <label htmlFor={id} className={girisEtiketCls}>
        {etiket}
      </label>
      <div className="relative mb-3">
        <input
          id={id}
          type={gorunur ? 'text' : 'password'}
          className={`${girisInputCls} pr-10`}
          value={deger}
          onChange={(e) => degisti(e.target.value)}
          autoComplete="new-password"
          required
        />
        <button
          type="button"
          onClick={() => setGorunur((g) => !g)}
          aria-label={gorunur ? `${etiket}: gizle` : `${etiket}: göster`}
          className="absolute right-0 top-0 w-10 h-[44px] flex items-center justify-center bg-transparent text-[#6b6b6e] hover:text-[#2f2f31] cursor-pointer"
        >
          {gorunur ? <I.EyeOff size={16} /> : <I.Eye size={16} />}
        </button>
      </div>
    </>
  );
}
